import React from 'react';
import { SIcon } from '@avalara/skylab-sdk/react';
import styled from 'styled-components';
import { COLORS } from '@avalara/bat-apps-shared/lib/constants';
import { saveTimeText, informationYouNeedBulletContent, } from '../constants';
const InfoWrapper = styled.div `
  align-items: center;
  background-color: ${COLORS.lightestGray};
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 0px auto;
  padding-bottom: 30px;

  div {
    width: 45%;
  }

  s-icon {
    color: ${COLORS.darkBlue};
  }

  p {
    font-size: 18px;
    line-height: 24px;
  }
`;
const InformationYouNeed = () => (React.createElement(InfoWrapper, null,
    React.createElement("h2", { "data-ref": 'buy.risk-assessment.thankyou.info-header', className: 'alt pad-top-lg pad-bottom-sm text-center' }, saveTimeText),
    React.createElement("div", null, informationYouNeedBulletContent.map((bulletText, i) => React.createElement("p", { key: i, "data-ref": `buy.risk-assessment.thankyou.info-content-${i}`, className: informationYouNeedBulletContent.length > 1 ? 'pad-all-xs' : 'pad-all-xs text-center' },
        informationYouNeedBulletContent.length > 1 &&
            React.createElement(SIcon, { name: 'check', className: 'pad-right-xs', "aria-label": 'check mark for bulleted text' }),
        bulletText)))));
export default InformationYouNeed;
